const loyaltyAccountRoutes = [
    {
        path: '/loyalty-account',
        name: 'loyaltyAccountList',
        component: () => import('@/modules/loyalty_account/list/List.vue'),
        meta: {
            resource: 'loyalty-accounts',
            action: 'view',
            layout: 'default',
            auth: true,
            title: 'Loyalty Accounts',
            breadcrumbs: [{ title: 'Loyalty Accounts', routeName: 'loyaltyAccountList' }]
        }
    }
]

export default loyaltyAccountRoutes
